import { useMemo } from 'react';
import { useI18nStore } from '../store';
import { currencyFormatters } from '../utils/currencyFormatters';
import { formatters } from '../utils/formatters';
import { translate } from '../utils/translate';

export const useI18n = () => {
  const {
    translations,
    showKeysForContentManager,
    timezone,
    dateFormats,
    language,
    currencyFormats
  } = useI18nStore([
    'translations',
    'showKeysForContentManager',
    'timezone',
    'dateFormats',
    'language',
    'currencyFormats'
  ]);

  /**
   * @type {function(tKey:String, replacers:(String|Array<String>)=, defaultTranslation: String=): (String)}
   */
  const t = useMemo(
    () => translate(translations, showKeysForContentManager),
    [translations, showKeysForContentManager]
  );

  const f = useMemo(
    () => formatters(timezone, dateFormats, t),
    [timezone, dateFormats, t]
  );

  const c = useMemo(
    () => currencyFormatters(language, currencyFormats),
    [language, currencyFormats]
  );

  return {
    t,
    f,
    c,
    language,
    timezone
  };
};
